import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "max-w-[40rem] mx-auto pb-5" }
const _hoisted_2 = { class: "px-3 pt-5 rounded-b-base shadow-base mb-5" }
const _hoisted_3 = { class: "flex gap-5" }
const _hoisted_4 = { class: "flex flex-shrink-0" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "font-black text-3xl z-10" }
const _hoisted_7 = { class: "font-normal text-base block" }
const _hoisted_8 = { class: "italic py-4" }
const _hoisted_9 = { class: "flex justify-between px-8 pt-5" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center font-bold"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-70 font-normal" }, "Posts", -1)
const _hoisted_12 = { class: "flex flex-col items-center font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-70 font-normal" }, "Employees", -1)
const _hoisted_14 = { class: "flex flex-col items-center font-bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-70 font-normal" }, "Followers", -1)
const _hoisted_16 = { class: "flex justify-between border-t-1 border-light-gray-300 py-5 mt-5" }
const _hoisted_17 = ["onClick"]

import { ref, onMounted, computed, watch } from "vue"
  import { filter, find, includes } from "lodash"
  import { useRoute } from "vue-router"
  import { useCompanyStore } from "@/store/company"
  import { useNewsFeedStore } from "@/store/newsfeed"
  import { useMetadataStore } from "@/store/metadata"
  import { useResourcesStore } from "@/store/resources"
  import { useGtm } from "@gtm-support/vue-gtm"
  import { arrowBackCircle, checkmarkCircle } from "ionicons/icons"
  import { IonButton, IonPage, IonSlides, IonSlide, IonLoading, useIonRouter } from "@ionic/vue"
  import follow from "@/utils/follow"

  // components
  import AboutPage from "@/views/workbean-page/AboutPage.vue"
  import JobPage from "@/views/workbean-page/JobPage.vue"
  import HomePage from "@/views/workbean-page/HomePage.vue"
  import CulturePage from "@/views/workbean-page/CulturePage.vue"
  import EBPMask from "@/components/workbean-page/culture/EbgImageObject.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyPage',
  setup(__props) {

  const slideOpts = {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    initialSlide: 0,
    loop: true,
    speed: 400,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  }

  const activeTab = ref("")
  const route = useRoute()
  const router = useIonRouter()
  const store = useCompanyStore()
  const newsfeedStore = useNewsFeedStore()
  const metadata = useMetadataStore()
  const resourcesStore = useResourcesStore()
  const gtm = useGtm()
  const loading = ref(false)
  const companyDetails = computed(() => store.companyDetails)
  const feedList = computed(() => filter(newsfeedStore.newsfeedList, "answer_content"))
  const ebpList = computed(() => resourcesStore.ebp)
  const companyEbp = computed(() => companyDetails.value.insight.ebp || { id: "" })
  const ebpObject = computed(() => find(ebpList.value, { id: companyEbp.value.id }))
  const newsFeedParams = ref({
    feed: "",
    company: "",
    user: "",
    limit: "",
    page: "",
  })
  const following = ref(false)

  const options = ["about", "job", "culture", "post"]

  /**
   * check follow
   * if true then return already follow
   * else follow the job
   */
  const onFollow = () => {
    if (!localStorage.getItem("WBSAASAPP_TK")) window.location.href = "/login"
    else if (following.value) follow.alreadyFollowing()
    else {
      follow.followJobOrCompany("company", companyDetails.value.slug, gtm)
      following.value = !following.value
    }
  }

  // Redirects to the specific tab inside company page
  const redirect = (tab: string) => {
    if (tab === "about") {
      router.push(`/company/${route.params.slug}`)
    } else if (tab !== route.params.tab && tab !== "about") {
      router.push(`/company/${route.params.slug}/${tab}`)
    }
    activeTab.value = tab
  }

  /**
   * redirect back to discover page
   */
  const back = () => {
    window.location.href = "/"
  }

  const initialize = async () => {
    checkTabNames(route.params.tab as string)
    loading.value = true
    newsFeedParams.value.company = route.params.slug as string
    await resourcesStore.retrieveEBPList()
    await store.retrieveCompanyDetails(route.params.slug as string)

    if (companyDetails.value.subscription === "Free") {
      activeTab.value = "about"
      redirect("about")
    } else {
      activeTab.value = (route.params.tab as string) !== "" ? (route.params.tab as string) : "about"
    }

    if (activeTab.value === "post") {
      store.isNewState = true
      await store.retrieveAllJobs(
        {
          columns: "title,type,slug,condition,display_link,created,updated,department,job_id,apply_link",
        },
        route.params.slug as string
      )
      await newsfeedStore.retrieveFeed(newsFeedParams.value)
    }

    following.value = follow.status("company")
    updateMeta()
    updateTitleMeta(route.params.tab as string)

    loading.value = false
  }

  const checkTabNames = (name: string) => {
    const acceptableTabs = ["post", "culture", "job"]
    if (name && !includes(acceptableTabs, name)) window.location.href = "/not-found"
  }

  const updateMeta = () => {
    metadata.details.description = companyDetails.value.metadata && companyDetails.value.metadata.description !== "" ? companyDetails.value.metadata.description : `${companyDetails.value.tagline}`
    metadata.details.og.description = companyDetails.value.metadata && companyDetails.value.metadata.description !== "" ? companyDetails.value.metadata.description : `${companyDetails.value.tagline}`
    metadata.details.og.image = `${companyDetails.value.logo}`
    metadata.details.og.url = window.location.href
    metadata.details.og.site_name = "Workbean"
    metadata.details.og.author = `${companyDetails.value.name}`
    ;(metadata.details.og.canonical = window.location.href), (metadata.details.twitter.image = `${companyDetails.value.logo}`)
    metadata.details.twitter.description =
      companyDetails.value.metadata && companyDetails.value.metadata.description !== "" ? companyDetails.value.metadata.description : `${companyDetails.value.tagline}`
    metadata.details.twitter.site = window.location.href
    metadata.details.twitter.creator = `${companyDetails.value.name}`
    metadata.details.og.image = companyDetails.value.logo
  }

  const updateTitleMeta = (tab: string) => {
    const companyNameAndCountry = `${companyDetails.value?.name} ${companyDetails.value?.name.includes(companyDetails.value?.location.country) ? "" : companyDetails.value?.location.country}`
    switch (tab) {
      case "about" && "":
        metadata.details.title =
          metadata.details.og.title =
          metadata.details.twitter.title =
            companyDetails.value.metadata && companyDetails.value.metadata.title !== ""
              ? companyDetails.value.metadata.title
              : `${companyDetails.value.name} ${companyDetails.value.location.country} Careers, Hiring & Job Openings`
        break
      case "job":
        metadata.details.title = metadata.details.og.title = metadata.details.title = metadata.details.twitter.title = metadata.details.title = `Job Openings at ${companyNameAndCountry}`
        break
      case "culture":
        metadata.details.title = metadata.details.og.title = metadata.details.title = metadata.details.twitter.title = metadata.details.title = `Culture at ${companyNameAndCountry}`
        break
      case "post":
        metadata.details.title = metadata.details.og.title = metadata.details.twitter.title = metadata.details.title = `Workbean posts from ${companyNameAndCountry}`
    }
  }

  onMounted(() => {
    localStorage.removeItem("backLink")
    initialize()
  })
  watch(
    () => route.params.tab,
    (val) => {
      if (route.path.includes("/company/")) {
        activeTab.value = val && options.includes(val as string) ? (val as string) : "about"
        checkTabNames(val as string)
        updateTitleMeta(val as string)
        updateMeta()
      }
    }
  )

  watch(
    [companyDetails, route.params.tab],
    () => {
      updateMeta()
    },
    { deep: true }
  )

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLoading), {
            "is-open": loading.value,
            message: "Loading...",
            spinner: null
          }, null, 8, ["is-open"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex", { 'absolute z-10': _unref(companyDetails).gallery?.length }])
            }, [
              _createVNode(_component_ion_icon, {
                class: "text-3xl text-gray-300 pl-3 py-3",
                icon: _unref(arrowBackCircle),
                onClick: back
              }, null, 8, ["icon"])
            ], 2),
            (_unref(companyDetails).gallery?.length)
              ? (_openBlock(), _createBlock(_unref(IonSlides), {
                  key: 0,
                  ref: "slides",
                  options: slideOpts,
                  pager: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyDetails).gallery, (galleryItem) => {
                      return (_openBlock(), _createBlock(_unref(IonSlide), {
                        key: `${galleryItem.label}_id`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "bg-clip-border bg-cover bg-origin-border bg-no-repeat bg-center h-[23rem] w-full flex",
                            style: _normalizeStyle({ 'background-image': `url(${galleryItem.image})` })
                          }, null, 4)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 512))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "w-16 h-16 rounded-base object-center object-cover flex-shrink-0",
                    src: _unref(companyDetails).logo,
                    alt: _unref(companyDetails).name
                  }, null, 8, _hoisted_5),
                  (_unref(companyDetails).subscription !== 'Free' && _unref(companyEbp).id.length > 0 && _unref(ebpObject))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "mt-7 rounded-full px-[3px] py-[3px] border-[4px] border-white h-10 w-10 flex justify-center flex-shrink-0 flex-grow-0",
                        style: _normalizeStyle({ background: _unref(ebpObject)?.color })
                      }, [
                        _createVNode(EBPMask, {
                          label: _unref(ebpObject)?.name,
                          color: "#ffffff",
                          height: "40px",
                          width: "40px"
                        }, null, 8, ["label"])
                      ], 4))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h1", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_unref(companyDetails).name) + " ", 1),
                    _createVNode(_component_ion_icon, {
                      class: "text-wizard-education text-3xl -mb-1",
                      icon: _unref(checkmarkCircle)
                    }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(companyDetails).location.city) + ", " + _toDisplayString(_unref(companyDetails).location.country), 1)
                ])
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(companyDetails).tagline), 1),
              _createVNode(_unref(IonButton), {
                expand: "block",
                color: "white",
                style: _normalizeStyle({ backgroundColor: _unref(companyDetails).brand_color || '#7442c8' }),
                class: "text-white font-bold rounded-[4px] shadow-base",
                disabled: following.value,
                onClick: onFollow
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(following.value ? "Following" : "Follow"), 1)
                ]),
                _: 1
              }, 8, ["style", "disabled"]),
              _createElementVNode("div", _hoisted_9, [
                (activeTab.value === 'home')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_unref(feedList).length) + " ", 1),
                      _hoisted_11
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_unref(companyDetails).number_of_employees) + " ", 1),
                  _hoisted_13
                ]),
                _createElementVNode("span", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_unref(companyDetails).follows ? _unref(companyDetails).follows.length : "0") + " ", 1),
                  _hoisted_15
                ])
              ]),
              _createElementVNode("ul", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyDetails).subscription === 'Free' ? ['about'] : options, (option) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${option}_id`,
                    class: "capitalize cursor-pointer",
                    style: _normalizeStyle(
                activeTab.value === `${option}`
                  ? {
                      'border-bottom-width': '4px',
                      'margin-bottom': '-1.25rem',
                      'font-weight': 700,
                      color: _unref(companyDetails).brand_color || '#7442c8',
                    }
                  : ''
              ),
                    onClick: ($event: any) => (redirect(option))
                  }, _toDisplayString(option), 13, _hoisted_17))
                }), 128))
              ])
            ]),
            (activeTab.value === 'about')
              ? (_openBlock(), _createBlock(AboutPage, { key: 1 }))
              : _createCommentVNode("", true),
            (activeTab.value === 'job')
              ? (_openBlock(), _createBlock(JobPage, {
                  key: 2,
                  "company-color": _unref(companyDetails).brand_color
                }, null, 8, ["company-color"]))
              : _createCommentVNode("", true),
            (activeTab.value === 'post')
              ? (_openBlock(), _createBlock(HomePage, { key: 3 }))
              : _createCommentVNode("", true),
            (activeTab.value === 'culture')
              ? (_openBlock(), _createBlock(CulturePage, { key: 4 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})